<template>
	<div class="card relative z-20 border border-gray-200/50 dark:border-gray-700/50 shadow-sm overflow-visible">
		<div class="card-body">
			<div class="flex flex-col sm:flex-row gap-4">
				<!-- Search -->
				<div class="flex-1">
					<SearchBar
						:modelValue="search"
						@update:modelValue="$emit('update:search', $event)"
						:placeholder="placeholder"
					/>
				</div>

				<!-- Status Filter -->
				<div class="flex w-full sm:w-auto gap-3">
					<FilterDropdown
						:modelValue="status"
						@update:modelValue="$emit('update:status', $event)"
						:label="displayLabel"
						:options="computedOptions"
					/>

					<!-- Per Page Selector -->
					<FilterDropdown
						v-if="perPage !== undefined"
						:modelValue="String(perPage)"
						@update:modelValue="$emit('update:perPage', Number($event))"
						label="Per Page"
						:options="perPageOptions"
					/>
				</div>

				<!-- Action Slot -->
				<slot name="action" />
			</div>
		</div>
	</div>
</template>


<script setup lang="ts">
import { computed } from 'vue'
import SearchBar from '@/components/ui/SearchBar.vue'
import FilterDropdown from '@/components/ui/FilterDropdown.vue'

const props = defineProps<{
	search: string
	status: string
	placeholder?: string
	options?: { value: string; label: string }[]
	filterLabel?: string
	perPage?: number
}>()

defineEmits<{
	(e: 'update:search', value: string): void
	(e: 'update:status', value: string): void
	(e: 'update:perPage', value: number): void
}>()

const defaultOptions = [
	{ value: 'all', label: 'All Status' },
	{ value: 'active', label: 'Active' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'pending', label: 'Pending' }
]

const computedOptions = computed(() => props.options || defaultOptions)

const displayLabel = computed(() => props.filterLabel || 'Status')

const perPageOptions = [
	{ value: '10', label: '10 per page' },
	{ value: '20', label: '20 per page' },
	{ value: '50', label: '50 per page' },
	{ value: '100', label: '100 per page' }
]
</script>
